import { createContext } from 'react';

export interface PostCallSummaryContextType {
  voiceCallId: number | null;
  isReadOnly?: boolean;
  setVoiceCallId: (voiceCallId: number | null) => void;
}

const PostCallSummaryContext = createContext<PostCallSummaryContextType>(null);

export default PostCallSummaryContext;
